import React, { useState } from 'react';
import './LoginPage.css';
import { useLoginProvider } from '../../context/LoginContext'; 
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';
import { db, auth } from '../../firebase/firebaseConfig';
import { toast } from 'react-toastify';
import { doc, setDoc } from 'firebase/firestore';
import vc2 from '../../assets/img/vc2.png';
import SignupModal from './SignupModal';
import Banner from '../Banner/Banner';
import { useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2'; // Import PhoneInput
import 'react-phone-input-2/lib/style.css'; // Import PhoneInput styles

const LoginPage = () => {
  const { login } = useLoginProvider(); 
  const [isSignUp, setIsSignUp] = useState(false);
  const [showSignupModal, setShowSignupModal] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState(''); // Change phone number state to hold full number
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSignUpClick = () => {
    setIsSignUp(true);
  };

  const handleSignInClick = () => {
    setIsSignUp(false);
  };

  const generateBankDetails = () => {
    const generateRandomNumber = () => {
      return Math.floor(1000000000000000 + Math.random() * 9000000000000000).toString(); // Generates a 16-digit number
    };

    const currentDate = new Date().toISOString().split('T')[0]; 

    const mockBankDetails = {
      accountNumber: generateRandomNumber(),
      accountBalance: parseFloat((0 * 10000).toFixed(2)), 
      accountOpeningDate: currentDate, 
      transactions: [], 
    };

    return mockBankDetails;
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
  
      // await sendEmailVerification(user);
     
     
    
      // Generate bank details after sign-up
      const bankDetails = generateBankDetails();
  
      await setDoc(doc(db, 'users', user.uid), {
        bankDetails: bankDetails,
        personalInfo: {
          name: name, 
          email: email,
          phone: phone 
        }
      }, { merge: true });

      toast.success('Please enter additional details to complete your profile.');
    
      setIsSignUp(false);
      setShowSignupModal(true);
     
   
    } catch (error) {
      setError(error.message);
      toast.error(error.message);
    }
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email.toLowerCase(), password);
      const user = userCredential.user;
  
   
        const token = await user.getIdToken(); 
        toast.success('Successfully Signed In');
        login(user.email, user.displayName || name, user.uid);
        navigate('/banking/dashboard');
      
    } catch (error) {
      if (error.code === 'auth/user-not-found' ) {
        setError('User not found. Kindly sign up.');
        toast.error('User not found. Kindly sign up.');
        setIsSignUp(true); 
      } else if (error.code === 'auth/wrong-password') {
        setError('Incorrect password. Please try again.');
        toast.error('Incorrect password. Please try again.');
        setIsSignUp(true); 
      } else if(error.code === 'auth/invalid-credential'){
        setError('Invalid credentials. Please try again.');
        toast.error('Invalid credentials. Please try again.');
      } else {
        setError(error.message);
        toast.error(error.message);
        setIsSignUp(true); 
      }
    }
  };

  const closeModal = () => {
    setShowSignupModal(false);
  };

  return (
    <>
      <div className="register-page topmar">
        <div className="promotion-section">
          <img src={vc2} alt="" />
          <h2>Enjoy <span className="offer-amount">Contactless Banking</span> With Us</h2>
          <div className="powered" role="group" aria-label="Security and regulatory badges">
  <span className="powered-label">Powered by</span>
  <ul className="powered-badges">
    <li className="badge">
      {/* Shield icon */}
      <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M12 3l7 3v6c0 4.418-3.134 8.418-7 9-3.866-.582-7-4.582-7-9V6l7-3z"
              stroke="currentColor" strokeWidth="1.6" fill="currentColor" opacity=".15"/>
        <path d="M12 3l7 3v6c0 4.418-3.134 8.418-7 9-3.866-.582-7-4.582-7-9V6l7-3z"
              stroke="currentColor" strokeWidth="1.6"/>
      </svg>
      FDIC Insured
    </li>

  {/* --- Add under <ul className="powered-badges"> --- */}

{/* PCI DSS Compliant */}


{/* SOC 2 Type II */}
<li className="badge" title="SOC 2 Type II">
  <svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" fill="none"/>
    <path d="M8.5 12.5l2.5 2.5 4.5-5" stroke="currentColor" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
  SOC 2 Type II
</li>

{/* Multi-Factor Authentication */}
<li className="badge" title="Multi-Factor Authentication">
  <svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path d="M7 17h10M9 7h6M5 12h14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <circle cx="9" cy="7" r="2" fill="currentColor"/>
    <circle cx="15" cy="12" r="2" fill="currentColor"/>
    <circle cx="12" cy="17" r="2" fill="currentColor"/>
  </svg>
  MFA Enabled
</li>

{/* Real-time Fraud Monitoring */}
<li className="badge" title="Real-time Fraud Monitoring">
  <svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="7" stroke="currentColor" strokeWidth="1.6" fill="none"/>
    <path d="M12 9v3l2 2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
  Fraud Monitoring
</li>

{/* Data Privacy */}
<li className="badge" title="Privacy & Data Protection">
  <svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path d="M12 4l7 3v5c0 3.5-2.7 6.7-7 8-4.3-1.3-7-4.5-7-8V7l7-3z"
          stroke="currentColor" strokeWidth="1.6" fill="currentColor" opacity=".12"/>
    <path d="M9 11h6M9 14h4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
  </svg>
  Privacy Protected
</li>

  </ul>
</div>
        </div>
        <div className="login-section">
          {isSignUp ? (
            <>
              <h2>Sign Up</h2>
              <form className="signup-form login-form" onSubmit={handleSignUp}>
                <label>
                  Name
                  <input
                    type="text"
                    placeholder="Full Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </label>
                <label>
                  Email
                  <input
                    type="email"
                    placeholder="Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </label>
                <label > 
                  Phone Number
                  <PhoneInput
                  className='phone-input'
                    country={'us'} // Default country (USA)
                    value={phone}
                    onChange={setPhone} // Set phone number
                    required
                  />
                </label>
                <label>
                  Password
                  <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </label>
                <button type="submit" className="sign-in-btn">Sign Up</button>
                {error && <p className="error">{error}</p>}
              </form>
              <div className="form-links">
                <a href onClick={handleSignInClick}>Already have an account? Sign in.</a>
              </div>
            </>
          ) : (
            <>
              <h2>Welcome</h2>
              <form className="login-form" onSubmit={handleSignIn}>
                <label>
                  Email
                  <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </label>
                <label>
                  Password
                  <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </label>
                <div className="login-options">
                  <label>
                    <input type="checkbox" /> <span> Remember me</span>
                  </label>
                </div>
                <button type="submit" className="sign-in-btn">Sign in</button>
                {error && <p className="error">{error}</p>}
                <div className="form-links">
                  <a href>Forgot username/password?</a>
                  <a href onClick={handleSignUpClick}>Not Enrolled? Sign Up Now.</a>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
      <Banner />
      {showSignupModal && <SignupModal onClose={closeModal} />}
    </>
  );
};

export default LoginPage;
